<app-base-grid-page
  [posts]="posts"
  [isLoading]="isLoading"
  [itemsCount]="itemsCount"
  [pagesCount]="pagesCount"
  thumbnailType="AUDIO"
  title="Cărți și povestiri audio creștine"
  searchPlaceholder="Caută povestiri"
  (getData)="getData($event)"
></app-base-grid-page>
